import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { V_PARTNER_KEINE_ANGABEN_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';

// import schemas
import DownloadIcon from '@mui/icons-material/Download';
import { Button, Stack, Typography } from '@mui/material';
import { cloneDeep, concat, get, set } from 'lodash';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { PROJEKTUEBERSICHT_LOEWE_PATH } from 'src/lib/constants/componentsPath';
import { PUBLIC_DOCUMENTS_PATHS } from 'src/lib/constants/publicDocumentPaths';
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import { NonRequired, Required } from 'src/lib/validation/ValidationTypes';
import { InhaltTrenner, InhaltWrapper } from 'src/pages/private/online-antrag/antrag-components/Wrapper';
import { addIndexesToPath, handleDownloadFile } from 'src/utils/helper';
const P = Schema.attributes;

const FoerderprojekteSkizzeGlobal: FC<{ unternehmenId: number; unternehmenName: string; isHochschule: boolean; positionId?: string }> = ({
	unternehmenId,
	isHochschule,
	positionId,
}) => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	const handleUpdateDaten = (key: string, value: any, rusIndex: number) => {
		let appCopy = cloneDeep(application);
		set(appCopy, key, value);
		const unternehmenPath = addIndexesToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Projektuebersicht.schema.attributes.Unternehmen.path,
			[`${rusIndex}`],
			['Projektuebersicht'],
		);
		if (Number(get(appCopy, `${unternehmenPath}.id`, null)) > 0) {
			// DO Nothing, since the unternehmen ID already exist
		} else {
			set(appCopy, unternehmenPath, unternehmenId);
		}

		setApplicationProperty('attributes', get(appCopy, 'attributes'));
	};

	if (unternehmenId) {
		return (
			<>
				{get(application, P.Projektbeschreibung_Loewe.schema.attributes.Projektuebersicht.path, []).map((ele: any, i: number) => {
					if (
						(Number(get(ele, `${PROJEKTUEBERSICHT_LOEWE_PATH.Unternehmen}.id`, null)) === unternehmenId &&
							!get(ele, PROJEKTUEBERSICHT_LOEWE_PATH.PositionID, null)) ||
						get(ele, PROJEKTUEBERSICHT_LOEWE_PATH.PositionID, '') === positionId
					) {
						return (
							<>
								<InhaltWrapper>
									<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
										Übersicht Förderprojekte
									</Typography>
									{isHochschule ?
										<Typography>
											<strong>Für Hochschulen und Forschungseinrichtungen</strong> ist die Einreichung einer Übersicht der Förderprojekte
											<strong>
												{' '}
												<u>nicht</u> erforderlich.
											</strong>
										</Typography>
									:	<Typography>
											Im Rahmen Ihrer Antragsstellung ist es erforderlich, dass Sie für Ihre Organisation angeben, ob Sie in den
											vergangenen 5 Jahren vor Einreichung dieser Skizze Fördermittel erhalten haben (laufende und abgeschlossene
											Projekte).{' '}
											<strong>
												Bitte beachten Sie, dass wir in jedem Fall eine ausgefüllte und unterzeichnete Erklärung von Ihnen benötigen.
											</strong>
										</Typography>
									}
								</InhaltWrapper>
								{!isHochschule && (
									<>
										<InhaltTrenner marginTop={'2rem'} />
										<InhaltWrapper>
											<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
												Download der Übersicht Förderprojekte
											</Typography>
											<Typography>Bitte laden Sie hier Ihre Vorlage für die Übersicht Förderprojekt herunter:</Typography>
											<Stack direction={'row'} spacing={2}>
												<Button
													variant={'outlined'}
													startIcon={<DownloadIcon />}
													sx={{ maxWidth: 'fit-content' }}
													onClick={() => handleDownloadFile(PUBLIC_DOCUMENTS_PATHS.antragsUnterlagen.Loewe.Projektuebersicht)}
												>
													Liste_Foerderprojekte
												</Button>
											</Stack>
											<Typography>
												<strong>Bitte beachten Sie:</strong> Jedes beteiligte Unternehmen muss diese Erklärung für die eigene Organisation
												ausfüllen. Die Unterzeichnung der Übersicht Förderprojekte muss per eigenhändiger Unterschrift erfolgen. Das
												Einfügen einer Bilddatei o.Ä. als Unterschrift ist nicht zulässig. Bitte speichern Sie die unterzeichnete
												Erklärung anschließend als pdf- Datei ab.
											</Typography>
										</InhaltWrapper>
										<InhaltTrenner marginTop={'2rem'} />
										<InhaltWrapper>
											<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
												Upload der Übersicht Förderprojekte
											</Typography>
											<Typography>
												Bitte laden Sie hier Ihre ausgefüllte und unterzeichnete Übersicht Förderprojekte (pdf-Datei) als
												Vorab-Information über das Upload-Feld hoch. Bitte behalten Sie den Dateinamen bei, Erweiterungen sind möglich.{' '}
											</Typography>
											<CreateForm
												formStruc={mapFormStruc(formStrucUpload(), i)}
												formValues={application}
												updateFormValuesFunc={(key, value) => handleUpdateDaten(key, value, i)}
												readOnly={readOnly}
											/>
										</InhaltWrapper>

										<InhaltTrenner marginTop={'2rem'} />
										<InhaltWrapper>
											<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
												Einreichung der Übersicht Förderprojekte{' '}
											</Typography>{' '}
											<Typography>
												Die Übersicht Förderprojekte ist Bestandteil des Förderantrags. Bitte lassen Sie uns diese - zusammen mit den
												weiteren Antragsdokumenten - fristgerecht im Original zukommen. Weitere Informationen finden Sie im Menüpunkt
												"Skizze einreichen".
											</Typography>
										</InhaltWrapper>
									</>
								)}
							</>
						);
					}

					return null;
				})}
			</>
		);
	}

	return <MUIAlert message={V_PARTNER_KEINE_ANGABEN_TEXT} />;
};

export default FoerderprojekteSkizzeGlobal;

const formStrucUpload = (isHochschule?: boolean): FormStrucItem[] => {
	return [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Projektuebersicht.schema.attributes
						.Projektuebersicht_Upload_Uebersicht_Foerderprojekte,
					label: '',
					/****
					 * Für die Component-Validierung müssen alle Array-Indizes ein eigenes
					 * Validierungsschema haben. Fehlt eines, kann ein Index versehentlich
					 * die Validierung eines anderen Index übernehmen.
					 */
					validation: [{ validateFunction: isHochschule ? NonRequired : Required }],
				},
			],
			userProps: { columnToDivide: 2 },
		},
	];
};

const mapFormStruc = (formStruc: FormStrucItem[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				return {
					...value,
					path: addIndexesToPath(get(value, 'path', ''), [`${index}`], ['Projektuebersicht']),
				};
			}),
		};
	});
	return result;
};

export const getFormStrucFoerderprojekteSkizzeGlobal = (application: any, unternehmenId: number, isHochschule: boolean, positionId?: string) => {
	let result: FormStrucItem[] = [];

	get(application, P.Projektbeschreibung_Loewe.schema.attributes.Projektuebersicht.path, []).forEach((ele: any, i: number) => {
		if (
			(get(ele, `${PROJEKTUEBERSICHT_LOEWE_PATH.Unternehmen}.id`, -1) === unternehmenId &&
				!get(ele, PROJEKTUEBERSICHT_LOEWE_PATH.PositionID, null)) ||
			get(ele, PROJEKTUEBERSICHT_LOEWE_PATH.PositionID, '') === positionId
		) {
			const formStrucUploadWithIndex = mapFormStruc(formStrucUpload(isHochschule), i);

			result = concat(result, formStrucUploadWithIndex);
		}
	});
	return result;
};
